export const DESCRIPTION_MIN_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 10000;

export const WORKED_DAYS_MAPPING = {
    ONE_DAY_PER_WEEK: 1,
    TWO_DAYS_PER_WEEK: 2,
    THREE_DAYS_PER_WEEK: 3,
    FOUR_DAYS_PER_WEEK: 4,
    FULL_TIME: 5,
};

export const MISSION_PROPOSAL_WORKED_DAYS_MAPPING: Record<string, number> = {
    ONE_DAY: 1,
    TWO_DAYS: 2,
    THREE_DAYS: 3,
    FOUR_DAYS: 4,
    FIVE_DAYS: 5,
    UNKNOWN: 0,
};
